(() => {
  document.addEventListener('init-grade_tag', (e) => {
    let $target = e.target;

    if ($target.classList.contains('initiated')) return;

    let $grade_tag_img = $target.querySelector('.grade-img');
    let tag = $grade_tag_img.dataset.tag;

    let img_url = GRADE_TAG_IMAGES.find(item => item.tag == tag).img_url;
    $grade_tag_img.src = img_url;

    // $target.querySelectorAll('.custom_grad_details').forEach((item) => {
    //   let $item = $(item);
    //   let height = $item.outerHeight();
    //   let item_top = height;
    //   if ($item.closest('#graph_container_sec').length) {
    //     item_top += 70;
    //   }
    //   $item.css('top', `-${ item_top }px`);
    // });

    let isMobile = window.matchMedia("(max-width: 767px)").matches;

    if (isMobile) {
      $target.addEventListener('click', (e) => {
        let tooltips = document.querySelectorAll('.custom_grad.active');

        // remove active state from others
        if (tooltips) {
          tooltips.forEach(tip => {
            if (tip != $target) tip.classList.remove('active');
          });
        }

        $target.classList.toggle('active');
      });
    }

    // if no horizontal space, move to left side
    // let target_position = ($grade_tag_img.getBoundingClientRect().left + $grade_tag_img.clientWidth) + 200;
    // if (target_position > window.innerWidth) {
    //   $target.classList.add('x-flip');
    // }

    $target.classList.add('initiated');
  });
})();